<template>
  <div class="upload-container">
    <div class="upload-preview" @click="$refs.fileUploader.click()">
      <!-- <div v-if="picSmall" class="uploadbox"> -->
      <div class="uploadbox">
        <img :src="picSmall ? picSmall : imgsHttp">
        <p class="uploadname">上传头像</p>
      </div>
      <!-- <i v-else class="el-icon-plus"></i> -->
    </div>
    <p class="upload-prompt">{{ $t('createPlant.imageLimit') }}</p>
    <!-- <div>
      <button
        class="upload-button"
        @click.prevent="$refs.fileUploader.click()"
      >
        <i class="iconfont icon-upload"></i>Upload
      </button>
      <p class="upload-prompt">{{$t('createPlant.imageLimit')}}</p>
    </div> -->

    <input type="file" class="upload-input" ref="fileUploader" accept="image/jpeg, image/png"
      @change="uploadImage($event)">
  </div>
</template>
<script>
export default {
  props: ['picBig', 'picSmall'],
  data() {
    return {
      imgsHttp: document.location.protocol + '//img.shinemonitor.com/img/2019/12/19/201912191850044046DC0FD27.png'
    };
  },
  methods: {
    // 上传图片
    uploadImage(event) {
      let file = event.target.files[0]
      if (file.size > 8 * 1024 * 1024) {
        this.$message.error(this.$t('createPlant.fileExceed'))
        return
      }
      this.$request.uploadImage(file).then(res => {
        if (res.err === 0) {
          this.$message.success(this.$t('createPlant.uploadSuccess'))
          this.$emit("update:picBig",  res.dat.picBig)
          this.$emit("update:picSmall",  res.dat.picSmall)
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
@import url("../assets/css/mixin.less");

.upload-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 25px;

  .upload-preview {
    border: 1px dashed #ccc;
    padding: 5px;
    border-radius: 5px;
    margin-bottom: 25px;
    .sc(0, #666);
    cursor: pointer;

    &:hover {
      color: @themeColor;
      border-color: @themeColor;
    }

    .uploadbox {
      display: flex;
      flex: 1;
      line-height: 130px;
      width: 130px;
      height: 130px;

      img {
        height: 130px;
        vertical-align: middle;
      }

      .uploadname {
        display: block;
        flex: 1;
        height: 30px;
        width: 100%;
        left: 0;
        bottom: 0;
        background-color: #000;
        color: #fff;
      }
    }

    i {
      line-height: 130px;
      width: 130px;
      text-align: center;
      font-size: 20px;
    }
  }

  // .upload-button {
  //   background: #fff;
  //   border: 1px solid @borderColor;
  //   cursor: pointer;
  //   padding: 8px 15px;
  //   border-radius: 5px;
  //   color: rgba(0, 0, 0, 0.6);
  //   font-size: 14px;
  //   i {
  //     color: #999;
  //     margin-right: 10px;
  //   }
  //   &:hover, &:focus {
  //     i {
  //       color: @themeColor;
  //     }
  //     color: @themeColor;
  //     border-color: @themeColor;
  //     background: #fff;
  //   }
  // }
  .upload-prompt {
    margin-top: 5px;
    line-height: 1.4;
    .sc(14px, rgba(0, 0, 0, 0.4));
  }

  .upload-input {
    display: none;
  }
}
</style>
